import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalQuestionsSlice = createSlice({
  name: "editModalQuestions",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalQuestionsSlice.actions;

export default editModalQuestionsSlice.reducer;